<!--begin::Body-->
<div class="kt-login__body auth-right">
	<!--begin::Signin-->

	<div class="customer-logo w-100">
		<img [src]="imagePaths.uptimeLogoOriginal" *ngIf="!logoUrl" alt="uptime-logo" width="75em" />
		<img [src]="logoUrl" *ngIf="logoUrl" width="75em" alt="logo"/>
	</div>
	<div class="kt-login__form d-flex flex-column form-body">
		<div *ngIf="hostClient === 'bpcl.uptimeai.com'" class="bpcl-slogan w-470">
			<span>{{ 'AUTH.LOGIN.BPCL_WELCOME' | translate }}</span>
		</div>
	    <div>
		<div class="kt-login__title w-470 mb-2">
			<h5 class="sign-in-text">{{ 'AUTH.LOGIN.BUTTON' | translate }}</h5>
		</div>

		<kt-auth-notice></kt-auth-notice>

		<!--begin::Form-->
		<form *ngIf="!environment.runtime.hidePasswordLogin || this.route.snapshot.queryParams['jgEN1n9DQEPnVsoV4NR0Ed17GUJvdq1H'] == 'O1CW8WTxEaDlRjcfAafj3cEhL6dx93iH'" class="kt-form login-form w-470" [formGroup]="loginForm" autocomplete="on">
			<div class="form-group form-entity d-flex flex-column pad-b-14">
				<kt-input
					[label]="'AUTH.INPUT.EMAIL' | translate"
					[placeholder]="'AUTH.PLACEHOLDER.EMAIL' | translate"
					formControlName="email"
					(inputBlur)="updateErrors()"
					[errorMessage]="emailErrorMessage"
					autocomplete="username">
				</kt-input>
			</div>
			<div class="form-group form-entity d-flex flex-column">
				<kt-input
					type="password"
					[label]="'AUTH.INPUT.PASSWORD' | translate"
					[placeholder]="'AUTH.PLACEHOLDER.PASSWORD' | translate"
					formControlName="password"
					(inputBlur)="updateErrors()"
					[errorMessage]="passwordErrorMessage"
					autocomplete="current-password">
				</kt-input>
			</div>
			<div class="d-flex justify-content-between mt-1">
			<mat-checkbox (change)="onRememBerMe($event)">{{ 'AUTH.LOGIN.REMEMBER_ME' | translate }}</mat-checkbox>
			<a href="javascript:;" routerLink="/web/forgot-password" class="kt-link kt-login__link-forgot forgot-password-text">
				{{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }}
			</a>
		   </div>
			<div class="form-group m-0 mt-4" *ngIf="recaptcha">
				<re-captcha (resolved)="resolved($event)" siteKey="{{siteKey}}"></re-captcha>
			</div>
			<!--begin::Action-->
			<div class="mt-4">
				<kt-button-v1
					variant="flat"
					class="auth-btn w-100"
					[fullWidth]="true"
					(btnClick)="submit()"
					[label]="'AUTH.LOGIN.BUTTON' | translate"
					[disabled]="(isCaptchaSelected && recaptcha) || loading"
					[style.--auth-bg]="((isCaptchaSelected && recaptcha) || loading) ? '#8B8B8D' : '#6340D5'"
					[loading]="loading">
				</kt-button-v1>
			</div>
			<!--end::Action-->
		</form>
		<div class="w-470 mt-4" *ngIf="enableOAuthSSO">
			<kt-button
				class="auth-secondary-btn auth-btn"
				[disabled]="loading"
				[image]="imagePaths.microsoftLogo"
				[label]="'AUTH.LOGIN.SIGN_IN_MICROSOFT' | translate"
				variant="outlined"
				color="#6340d5"
				labelColor="#6340d5"
				labelSize="14px"
				(onClick)="redirectUser()">
			</kt-button>
		</div>
		<div class="w-470 mt-4" *ngIf="enableSAMLSSO">
			<kt-button
				class="auth-secondary-btn auth-btn"
				[disabled]="loading"
				[label]="environment.runtime.SSO_SIGNIN_BUTTON_TEXT ? environment.runtime.SSO_SIGNIN_BUTTON_TEXT : ('AUTH.LOGIN.SIGN_IN_SAML' | translate)"
				variant="outlined"
				color="#6340d5"
				labelColor="#6340d5"
				labelSize="14px"
				(onClick)="redirectUserSAML()">
			</kt-button>
		</div>
		<!--begin::Head-->
		<!-- <div class="kt-login__head signup-head v-pad-10 w-470" style="margin-bottom:3vh" *ngIf = "!isSignup">
			<span class="signup-label kt-login__signup-label">Don't have an account yet?</span>&nbsp;&nbsp;
			<a href="javascript:;" routerLink="/web/register" class="kt-link kt-login__signup-link link-underline" style="font-weight: 400 !important;">{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}</a>
		</div> -->
<!--end::Head-->
		</div>
		<!--end::Form-->

		<!--begin::Divider-->
		<!-- <div class="kt-login__divider">
			<div class="kt-divider">
				<span></span>
				<span>OR</span>
				<span></span>
			</div>
		</div> -->
		<!--end::Divider-->

		<!--begin::Options-->
		<!-- <div class="kt-login__options">
			<a href="https://www.facebook.com/keenthemes/" target="_blank" class="btn btn-primary kt-btn">
				<i class="fab fa-facebook-f"></i>
				Facebook
			</a>

			<a href="https://twitter.com/keenthemes/" target="_blank" class="btn btn-info kt-btn">
				<i class="fab fa-twitter"></i>
				Twitter
			</a>

			<a href="javascript:;" class="btn btn-danger kt-btn">
				<i class="fab fa-google"></i>
				Google
			</a>
		</div> -->
		<!--end::Options-->
	</div>
	<!--end::Signin-->
</div>
<!--end::Body-->

<div *ngIf="code" class="loading">{{ 'AUTH.LOGIN.SIGNING_IN' | translate }}</div>